<template>
<div class="list_box_pagination">
    <div class="list_box  d-flex">
        <div class="listsize" :style="row" v-for="(item, i) in listbox.slice((page-1)*per_page, page*per_page)" :key="item.title + i">
            <a :href="item.url"   target="_blank"> 
                <div class="boxborder d-flex">
                    <div class="imgbox">
                        <img :src="item.cms_fb_image_url!=undefined?item.cms_fb_image_url:item.image_url" alt="">
                        <!-- <img :src="item.image_url" alt=""> -->
                    </div>
                    <div class="infobox d-flex">
                        <div class="title">{{item.title}}</div>
                        <div class="list_box_icon">
                            <p class="date"><i class="fa fa-calendar"></i>{{item.start_date}}~{{item.end_date.slice(5,10)}}</p>
                            <p class="location"><i class="fa fa-map-marker"></i>{{item.location}}</p>
                        </div>
                        <div class="button_display">{{item.button_display}} ⇀</div>
                    </div>
                </div>
            </a>
        </div>
        
    </div>
    <pagination v-model="page" 
        :page-range="1"
        :records="listbox.length" 
        :per-page="per_page" 
        :options="page_options"
        @paginate="clickScroll"></pagination>
</div>
    
</template>
<script>
// import IndexTitle from '@/components/index/IndexTitle'
import Pagination from 'vue-pagination-2'
export default {
    components: {
        // 'indexTitle': IndexTitle,
        'pagination': Pagination,
    },
    props:  [
        "listbox",
        "row",
    ],
    data () {
    return {
      page: 1,
      per_page: 12,
      page_options: {
          chunk :5,
          chunksNavigation :'scroll', 
        texts: {
          count: '{from}-{to}/{count} | {from}-{to}/{count} | ',
        //   count: ' {from} | {from}  | {from}  ',
        }
      },
    }
  },
  methods: {
    clickScroll() {
      document.documentElement.scrollTop = 0
    }
  },
    
}
</script>
<style>
.list_box{
    max-width: 1200px;
    flex-wrap:wrap ;
}
.list_box .listsize{
    box-sizing: border-box;
    padding: 10px;
    
}
.list_box .listsize a{
    text-decoration: none;
}
.list_box .boxborder{
    border:2px solid #eee;
    height: 100%;
    flex-direction: column;
}
.list_box .imgbox{
    width:100%;
    height: auto;
    /* float: left; */
}
.list_box .imgbox img{
    width:100%;
    height: 100%;
}
.list_box .infobox{
    color: black;
    padding: 10px 8px;
    /* padding: 100% ; */
    /* height: 100%; */
    flex-direction:column;
    justify-content:space-around;
    flex-grow: 1;
}
.list_box .title{
    font-size: 17px;
    font-weight: 700;
    line-height: 1.15;
    /* margin-top: 15px; */
    /* height: 60px; */
}
.list_box .date{
    font-size: 15px;
}
.list_box .location{
    font-size: 15px;
}
.list_box .button_display{
    font-size: 17px;
    font-weight: 700;
    color:#00a0e9;
}
.list_box .list_box_icon{
    font-size: 13px;
  }
.list_box .list_box_icon i{
    width: 15px;
    height: 15px;
    text-align: center;
    margin: 5px 5px 0 0;
 }
@media (max-width: 850px){
    .listsize{
        width: 33.3% !important;
    }
}
@media (max-width: 640px){
    .list_box .listsize{
        width: 50% !important;
        padding: 7px;
    }
    .list_box .title{
        font-size: 15px;
    }
    .list_box .date{
        font-size: 13px;
    }
    .list_box .location{
        font-size: 13px;
    }
    .list_box .button_display{
        font-size: 13px;
        font-weight: 700;
        color:#00a0e9;
    }
}
.list_box_pagination .page-link {
    color: black;
    font-weight: 700;
}

.list_box_pagination .VuePagination ul{
    list-style-type: none ;
    margin: 50px 0 20px;
    padding: 0;
    display: flex;
    justify-content: center;
}
.list_box_pagination .VuePagination ul .page-item{
    width: 50px;
    height: 50px;
    line-height: 44px;
    margin: 0px 3px;
    border: 2px solid #cccccc;
    text-align: center;
}
.list_box_pagination .VuePagination ul .page-item:hover{
    border: 2px solid #00a0e9;
}
.list_box_pagination .VuePagination ul .page-item.active{
    background: #00a0e9;
    border: 2px solid #00a0e9;
}
.list_box_pagination .VuePagination ul .page-item.active a{
    color: white;
}
.list_box_pagination .VuePagination ul .page-item a{
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
    color: #808080;
    font-size: 17px;
}
.list_box_pagination  .VuePagination__count {
    display: none;
}
</style>


